import * as types from 'modules/payments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = 0;

export default createReducer(initialState, {}, [
  {
    matcher: ({ type, meta }) => type === types.FETCH_TOTAL_AMOUNT_SUCCESS && meta?.source === 'payments-dashboard',
    reducer: (_, { payload: total }) => total,
  },
  {
    matcher: ({ type, meta }) => type === types.FETCH_TOTAL_AMOUNT_FAILURE && meta?.source === 'payments-dashboard',
    reducer: () => 0,
  },
]);
